import { useQuery, UseQueryOptions } from '@tanstack/react-query';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const FIVE_MINUTES = 5 * 60 * 1000;

const URL = '/api/list-referrals';

export type ListReferralsResponse = {
  referrals?: string[];
  error?: string;
};

const LIST_REFERRALS_KEY = ['referrals', 'list'] as const;

const listReferrals = async (): Promise<string[]> => {
  const response = await fetch(URL);

  if (!response.ok) {
    throw new Error('Failed to load referral sources');
  }

  const data: ListReferralsResponse = await response.json();

  return data.referrals ?? [];
};

export const useListReferralsQuery = (
  options?: Partial<UseQueryOptions<string[], Error>>
) =>
  useQuery<string[], Error>({
    queryKey: LIST_REFERRALS_KEY,
    queryFn: listReferrals,
    staleTime: FIVE_MINUTES,
    retry: 1,
    ...options,
  });
